import React, { useEffect, useState } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/fluent-light/theme.css';

function CheckIndoNepalTransaction() {
  const [data, setData] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { partnerId } = e.target;
      let requestData = {
        partnerId: partnerId.value
      };
      //const response = await axios.post("/remittance/search/transaction", requestData);
      const response = await axios.post("/prabhuRemittance/searchTransaction", requestData);
      const { status, message, details } = response.data;
      if (status) {
        toast(message);
        setData(details);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  function addSpaceBetweenCases(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1 $2');
  };

  return (
    <div class="content-wrapper">
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">
                Check Indo Nepal Transaction
              </h4>
              <form className="searchForm" onSubmit={handleSubmit}>
                <div class="row">
                  <div class="col-lg-6 col-md-6">
                    <label for="partnerId">Transaction Id</label>
                    <input class="form-control" type="number" name="partnerId" required />
                  </div>
                  <div class="col-lg-6 col-md-6">
                    <input type="submit" className="search-btn btn btn-primary" value="Search" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-lg-12 col-md-12">
                  {
                    (data && (Object.entries(data).length > 0)) && (
                      <>
                        <ul className="showData">
                          <li>
                            <strong>Sender:</strong>
                            <div>{data.sender.name}</div>
                          </li>
                          <li>
                            <strong>Mobile:</strong>
                            <div>{data.sender.mobile}</div>
                          </li>
                          <li>
                            <strong>Amount(₹):</strong>
                            <div>{data.pay_amount}</div>
                          </li>
                          <li>
                            <strong>Service Charge(₹):</strong>
                            <div>{data.service_charge}</div>
                          </li>
                          <li>
                            <strong>Send Amount(NPR):</strong>
                            <div>{data.send_amount}</div>
                          </li>
                          <li>
                            <strong>Pin Number:</strong>
                            <div>{data.p_transaction_pin}</div>
                          </li>
                          <li>
                            <strong>Reciever:</strong>
                            <div>{data.receiver.receiver}</div>
                          </li>
                          <li>
                            <strong>Status:</strong>
                            <div>{data.status}</div>
                          </li>
                        </ul>
                      </>
                    )
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CheckIndoNepalTransaction;
